import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

function formatDetail(detail) {
  if (detail == null) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="Crawford Construction" className="h-20 w-20 object-contain rounded-full ring-2 ring-gold/60 bg-white mx-auto" />
          <h1 className="font-display text-3xl text-white mt-5">Admin Portal</h1>
          <p className="text-white/50 text-sm mt-2">Crawford Construction & Development Ltd.</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white p-8 space-y-5">
          <label className="block">
            <span className="block text-xs uppercase tracking-widest font-semibold text-navy mb-2">Email</span>
            <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border border-gray-200 px-4 py-3 outline-none focus:border-gold" placeholder="admin@email.com" />
          </label>
          <label className="block">
            <span className="block text-xs uppercase tracking-widest font-semibold text-navy mb-2">Password</span>
            <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-gray-200 px-4 py-3 outline-none focus:border-gold" placeholder="••••••••" />
          </label>
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full flex items-center justify-center gap-2 bg-navy text-white py-3.5 font-bold hover:bg-navy-light transition-colors border border-transparent hover:border-gold disabled:opacity-60">
            <Lock size={16} /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
